<template>
  <section class="quick-search-news-child-card">
    <div class="icon icon-business-signal">
      <i class="fa fa-suitcase" />
    </div>

    <h5 class="title">
      {{ $t(`business_opportunity_type_${news_piece?.business_opportunity_type}`) }}
    </h5>

    <a
      :href="business_opportunity_url"
      class="business-opportunity"
    >
      {{ news_piece?.sample_title }}
    </a>

    <a
      :href="company_url"
      class="company"
    >
      {{ news_piece?.company?.name }}
      <span v-if="news_piece?.company?.group_name">({{ news_piece.company.group_name }})</span>
    </a>

    <div class="date">
      {{ $t('published_on') }}
      {{ $filters.formatDate(news_piece?.publication_date) }}
    </div>
  </section>
</template>

<script>
import configuration from '@/configurations';

export default {
  name: 'QuickSearchBusinessSignalNewsCard',
  props: {
    news_piece: Object,
  },
  data() {
    return {
      configuration,
    };
  },
  computed: {
    company_url() {
      return `/account/${this.news_piece?.company?.id}`;
    },
    business_opportunity_url() {
      const company_id = this.news_piece?.company?.id;
      let url = `/account/${company_id}`;

      url += `/news/business-opportunity/${this.news_piece?.id}`;

      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

.business-opportunity {
  color: $dark-blue;
  text-decoration: none;
}

.company {
  color: $azure-blue;
  display: block;
  font-family: 'GalanoGrotesqueAlt-Medium';
  font-size: 12px;
  margin-top: 2px;
  margin-bottom: 0px;
  text-decoration: none;
}

.date {
  color: $light-gray-blue;
  font-family: 'Fira Sans';
  font-size: 12px;
  font-style: italic;
  line-height: 12px;
  padding: 10px 0;
  text-transform: none;
}

.icon {
  align-items: center;
  border-radius: 20px;
  color: #fff;
  display: flex;
  width: 30px;
  flex-grow: 0;
  flex-shrink: 0;
  float:left;
  font-size: 14px;
  height: 30px;
  justify-content: center;
  margin-right: 20px;
}

.icon-business-signal {
  background: $indygo-blue;
}

.quick-search-news-child-card {
  color: $dark-blue;
  font-size: 13px;
  line-height: 18px;
  flex: 1 1 auto;

  a {
      display: inline-block;
  }
}

.title {
  color: $steel-blue;
  font-family: 'GalanoGrotesque-SemiBold';
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  margin-bottom: 10px;
  line-height: 12px;
  padding: 0;
  text-transform: uppercase;
}
</style>

<i18n src="@/locales/common.json"></i18n>

<i18n src="@/locales/components/elements/quick_search/news/quick-search-business-signal-news-card.json"></i18n>
